<template>
    <div class="cursus-app content page">
        <router-view
            :category="category"
            :per-page="perPage"
            :show-breadcrumb="showBreadcrumb"
            :breadcrumb="breadcrumb || []"
            :footer-items="footerItems"
            :course="course"
        >
            <template v-slot:prepend>
                <slot name="prepend" />
            </template>
            <slot />
        </router-view>
    </div>
</template>

<script>
  import { getFooterItems } from "../api";

  export default {
        props: {
            category: [Number, String],
            perPage: {
                type: Number,
                default: 15
            },
            showBreadcrumb: Boolean,
            breadcrumb: Array,
            course: Object, // to preview course page
        },
        data() {
            return {
                footerItems: [],
            }
        },
        async created() {
            this.footerItems = await getFooterItems();
        },
    }
</script>
